import React from 'react';

const ClubStructure = () => {
    return (
        <div>
            
        </div>
    );
}

export default ClubStructure;
